import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronDownSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 15.0605L17.0608 9.99989L16.0001 8.93923L12.0001 12.9392L8.00011 8.93923L6.93945 9.99989L12.0001 15.0605Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownSmall;
